// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"userTextMessage_mainContainer__5DhRy","userImg":"userTextMessage_userImg__3IgQw","messageContainer":"userTextMessage_messageContainer__58X_t"};